import React from 'react'
import { Link } from 'react-router-dom'
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import { useState } from 'react';
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import { Client, Databases, ID } from "appwrite"



const Footer = () => {

  const [email, setemail] = useState('')
  const [Names, setNames] = useState('')
  const [message, setMessage] = useState('')

  const create = (e) => {
    const client = new Client()
      .setEndpoint('https://cloud.appwrite.io/v1')
      .setProject('66da9a14000f970c8d3d');

    const databases = new Databases(client);
    e.preventDefault()
    const userDta = databases.createDocument(
      '66da9ac4001752138a64',
      '66da9af2002707555e9c',
      ID.unique(),
      { Names, email, message }
    );
    setNames('')
    setMessage('')
    setemail('')
  }

  return (
    <div className='bg-gray-800 text-white'>
      <div className="">
        <div className="flex justify-between items-center p-5">
          <div className=" border-r-2 p-8">
            <h1 className='text-4xl'>The Future of<br /> Advertising is Here</h1>
          </div>
          <div className="icon max-sm:mt-10 ">
            <div className="">
              <h1 className="text-4xl max-sm:ml-3 max-sm:text-2xl">Connect on!</h1>
            </div>
            <div className="flex gap-3 p-8">
              <span>
                <InstagramIcon />
              </span>
              <span>
                <TwitterIcon />
              </span>
              <span><FacebookIcon />
              </span>
            </div>
          </div>
          <div className="md:block contact px-14 max-sm:hidden ">
            <form onSubmit={create}>
              <div className="flex items-center gap-4 text-white bg-gray-800">
                <input value={Names} onChange={(e) => setNames(e.target.value)} type="text" placeholder="Your Name" className='bg-gray-800 text-white  border-b-2 outline-none mb-2' />
                <input value={email} onChange={(e) => setemail(e.target.value)} type="email" className='text-white bg-gray-800 border-b-2 outline-none mb-2' placeholder='Email' />
              </div>
              <div className="flex items-center gap-6">
                <textarea value={message} style={{ resize: "none" }} onChange={(e) => setMessage(e.target.value)} placeholder="Message " className='text-white mt-3 bg-gray-800 border-b-2 outline-none mb-2' />
                <div className="hover:outline  px-10 py-3 rounded-max-sm mt-5 ml-4">
                  <button type='submit' >
                    <SendOutlinedIcon /> Say Hi!
                  </button>
                </div>

              </div>
            </form>

          </div>
        </div>
        <div className="">


          <div className="bg-gray-800   shadow mr-4 ml-4 mt-4 mb-0 dark:bg-gray-800 border-t-2">
            <div className="w-full mx-auto max-w-screen-xl p-4 md:flex md:items-center md:justify-between">
              <span className="text-max-sm text-gray-500 max-sm:text-center dark:text-gray-400">© 2024 <Link to={'/'} className="hover:underline">Free Piyo</Link>.All Rights Reserved.
              </span>
              <ul className="flex gap-3 flex-wrap items-center mt-3 text-max-sm font-medium text-gray-500 dark:text-gray-400 max-sm:mt-0">
                <li>
                  <Link to={'/advertise'}>Advertise</Link>
                </li>

                <li>
                  <Link to={'/about'}>About</Link>
                </li>
                <li>
                  <Link to={'/contact'}>Contact Us</Link>
                </li>
              </ul>
            </div>
          </div>


        </div>
      </div>


    </div>
  )
}

export default Footer



